import React from "react"

interface JwksPatternSectionProps {
	urlPattern: string
	steps: string[]
	additionalInfo?: {text: string; link?: string}
}

export function JwksPatternSection({urlPattern, steps, additionalInfo}: JwksPatternSectionProps) {
	return (
		<div className="provider-info box">
			<div className="box-title">
				<p className="secondary">Your JWKS URL follows this pattern:</p>
				<p className="link">{urlPattern}</p>
			</div>

			<p className="list-title">Where to find it:</p>
			<ol>
				{steps.map((step, index) => (
					<li key={index}>{step}</li>
				))}
			</ol>

			{additionalInfo && (
				<div className="additional-info">
					<p className="secondary">{additionalInfo.text}</p>
					{additionalInfo.link && <p className="link">{additionalInfo.link}</p>}
				</div>
			)}
		</div>
	)
}
